import { CapiEvent } from '../../interface/eventInterface';
import { v4 as uuidv4 } from 'uuid';
import checkoutService from '../../api/checkoutService';

declare global {
  interface Window {
    phx: {
      track: (_data: object) => void;
      initialize: (_data: object) => void;
    };
  }
}

// Check if an external_id already exists, if not generate and store it
export const setOrGetExternalId = () => {
  if (!localStorage.getItem('external_id')) {
    // No ID found, generate a new one and store it
    localStorage.setItem('external_id', uuidv4());
  }
  return localStorage.getItem('external_id') || '';
};

export const getExternalId = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('cart') || '';
};

// Function to prepare common user data
export const prepareUserData = () => {
  const getQueryParam = (param: string) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  };

  const getCookie = (name: string) => {
    const cookies = document.cookie.split('; ');
    const cookie = cookies.find(row => row.startsWith(`${name}=`));
    return cookie ? cookie.split('=')[1] : null;
  };

  const fbclid = getQueryParam('fbclid');
  const _fbcValue = fbclid ? `fb.1.${Date.now()}.${fbclid}` : null;
  const _fbc = _fbcValue || getCookie('_fbc');
  const _fbp = getCookie('_fbp');

  console.log('_fbc : ', _fbc, '_fbp : ', _fbp);

  return {
    _fbp,
    _fbc,
  };
};

export const getMetaPayload = (uniqueId: string) => {
  const { _fbp, _fbc } = prepareUserData();
  return {
    metaPayload: {
      event_source_url: window.location.href,
      external_id: getExternalId(),
      event_id: uniqueId,
      fbp: _fbp ? _fbp : '',
      fbc: _fbc ? _fbc : '',
    },
  };
};

export const handleCapi = async (event: CapiEvent) => {
  try {
    const { ShopID, Cart, eventName, orderId, eventId } = event;

    // const generate_event_id = (event: string) => {
    //   // Create a new Date object for the current date and time
    //   const today = new Date();

    //   // Get the year, month, and day from the Date object
    //   const year = today.getFullYear();
    //   const month = String(today.getMonth() + 1).padStart(2, '0'); // Add 1 because months start at 0
    //   const day = String(today.getDate()).padStart(2, '0');

    //   // Combine the date string with an event-specific identifier
    //   const dateString = `${year}${month}${day}`;
    //   const eventID = `${dateString}_${event}`;

    //   console.log(eventID); // Outputs an event ID like "20240524_eventName"
    //   return localStorage.getItem('external_id') + '_' + eventID;
    // };

    // Check if an external_id already exists, if not generate and store it
    // const setOrGetExternalId = () => {
    //   if (!localStorage.getItem('external_id')) {
    //     // No ID found, generate a new one and store it
    //     localStorage.setItem('external_id', uuidv4());
    //   }
    //   return localStorage.getItem('external_id');
    // };

    if (!Cart || !Cart.LineItems) {
      console.warn('No order data found');
      return;
    }

    const getEvents = (eventName: string) => {
      try {
        if (eventName === 'Purchase') {
          const contents = Cart.LineItems.map(item => ({
            id: String(item.ProductID),
            description: item.Subtitle,
            quantity: item.Quantity,
            item_price: item.UnitPrice,
          }));
          const event_time = Math.floor(Date.now() / 1000);
          const { _fbp, _fbc } = prepareUserData();

          // const externalId = setOrGetExternalId();

          const eventData = [
            {
              event_name: 'Purchase',
              event_source_url: window.location.href, // Current page URL
              value: Cart?.TotalAmount,
              currency: Cart?.currencyCode || 'USD',
              contents, // This should be an array of product IDs
              content_type: 'product',
              event_time: event_time,
              event_id: eventId,
              action_source: 'website',
              user_data: {
                em: Cart?.Email ? Cart?.Email : undefined,
                ph: Cart?.PhoneNumber ? Cart?.PhoneNumber : undefined,
                country: Cart?.ShippingAddress?.CountryCode,
                fn: Cart?.ShippingAddress?.FirstName,
                ln: Cart?.ShippingAddress?.LastName,
                ct: Cart?.ShippingAddress?.City,
                st: Cart?.ShippingAddress?.ProvinceCode,
                zp: Cart?.ShippingAddress?.Zip,
                external_id: getExternalId(),
                fbp: _fbp ? _fbp : undefined,
                fbc: _fbc ? _fbc : undefined,
              },
              custom_data: {
                order_id: orderId,
              },
            },
          ];
          return eventData;
        } else {
          const event_time = Math.floor(Date.now() / 1000);
          const { _fbp, _fbc } = prepareUserData();

          // const externalId = setOrGetExternalId();
          const contents = Cart.LineItems.map(function (item) {
            return {
              id: String(item.ProductID),
              description: item.Subtitle,
              quantity: item.Quantity,
              item_price: item.UnitPrice,
            };
          });

          const eventData = [
            {
              event_name: eventName,
              event_source_url: window.location.href, // Current page URL
              currency: 'USD',
              contents, // This should be an array of product IDs
              content_type: 'product',
              event_time: event_time,
              event_id: eventId,
              action_source: 'website',
              user_data: {
                external_id: getExternalId(),
                fbp: _fbp,
                fbc: _fbc,
              },
            },
          ];
          return eventData;
        }
      } catch (error) {
        console.error('Error in getEvents function:', error);
      }
    };

    const dataToSend = {
      shopify_url: ShopID + '.myshopify.com',
      events: getEvents(eventName),
    };

    await checkoutService.sendCapiToServer(dataToSend);
  } catch (error) {
    console.error('Error in handleCapi:', error);
  }
};

export const handleEventLogger = ({
  eventType,
  apiDetails,
  shopifyDetails,
  cartDetails,
  eventToken,
}: {
  eventType: string;
  apiDetails: object;
  shopifyDetails: object;
  cartDetails?: object;
  eventToken: string | null;
}) => {
  try {
    window?.phx?.track({
      eventType,
      apiDetails,
      shopifyDetails,
      cartDetails,
      eventToken,
      eventFrom: 'CHECKOUT_BUILDER',
    });
  } catch (error) {
    console.error('Error in handleEventLogger:', error);
  }
};
